(function () {
  if (customElements.get('product-installment-options')) {
    return;
  }

  class ProductInstallmentOptions extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.listenForPriceChanges();
    }

    listenForPriceChanges() {
      document.addEventListener('variant:change', (event) => {
        this.updateInstallmentPrice(event.detail.variant);
      });

      document.addEventListener('price:change', (event) => {
        this.updateInstallmentPrice(event.detail);
      });
    }

    updateInstallmentPrice(variant) {
      if (!variant || !variant.price) return;

      const installmentElement = this.querySelector('.installment-option');
      if (!installmentElement) return;

      const installments = parseInt(this.dataset.installments) || 6;
      const interestFree = this.dataset.interestFree === 'true';

      const pricePerInstallment = variant.price / installments;

      const formattedPrice = this.formatPrice(pricePerInstallment);

      const interestText = interestFree ? ' sin interes' : '';
      installmentElement.textContent = `${installments} cuotas de ${formattedPrice}${interestText}`;
    }

    formatPrice(price) {
      const formatter = new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });

      return formatter.format(price);
    }
  }

  customElements.define('product-installment-options', ProductInstallmentOptions);
})();
